import { Button, Text, Form, FormField, FormInput } from 'atp-react-ui';

import { FormPasswordInput, SocialButton } from '@/_components';
import AchieveLogo from '@/_shared/img/achieve-logo.svg?react';

import { ContactSupportButton } from './components';
import { useLoginPageLogic } from './use-login-page-logic';

function Page() {
  const {
    form,
    isLoading,
    isLoadingGoogleLogin,
    ErrorNode,
    isLoadingFacebookLogin,
    facebookLoginDisabled,
    onSubmit,
    handleForgotPasswordClick,
    onGoogleLogin,
    onFacebookLogin,
  } = useLoginPageLogic();

  const isLoggingIn = isLoading || isLoadingGoogleLogin || isLoadingFacebookLogin;

  return (
    <div className="flex flex-col gap-y-6">
      <div className="self-center">
        <AchieveLogo />
      </div>
      {ErrorNode || (
        <>
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col space-y-4">
              <Text as="h3" className="self-center">
                Login
              </Text>

              <FormField
                control={form.control}
                name="email"
                render={({ field }) => <FormInput placeholder="xyz@abc.com" label="Email" {...field} />}
              />

              <FormField
                control={form.control}
                name="password"
                render={({ field }) => <FormPasswordInput type="password" label="Password" {...field} />}
              />

              <div>
                <Button as="link" size="xs" onClick={handleForgotPasswordClick}>
                  Forgot Password
                </Button>
                <Button
                  type="submit"
                  theme="primary"
                  className="mt-6"
                  block
                  disabled={isLoggingIn}
                  showLoader={isLoading}
                >
                  Login
                </Button>
              </div>
            </form>
          </Form>

          <div className="flex items-center">
            <div className="flex-1 border-b border-outline" />
            <Text as="caption-medium" className="mx-2 bg-white text-center text-accent-light">
              or login with
            </Text>
            <div className="flex-1 border-b border-outline" />
          </div>

          <div className="flex flex-col gap-y-6">
            <div className="flex flex-row items-center justify-evenly gap-2">
              <div className="w-1/2 shrink-0 grow-0">
                <SocialButton
                  type="google"
                  variant="large"
                  onClick={onGoogleLogin}
                  disabled={isLoggingIn}
                  isLoading={isLoadingGoogleLogin}
                />
              </div>
              <div className="w-1/2 shrink-0 grow-0">
                <SocialButton
                  variant="large"
                  type="facebook"
                  onClick={onFacebookLogin}
                  disabled={isLoggingIn || facebookLoginDisabled}
                  isLoading={isLoadingFacebookLogin}
                />
              </div>
            </div>

            <ContactSupportButton />
          </div>
        </>
      )}
    </div>
  );
}

export default Page;
